import type {
  PartnerDevicesInfoData,
  PartnerDevicesInfoDraft,
  PartnerDevicesInfoOverLastYears,
  PartnerDevicesInfoProcedureRow,
  PartnerDevicesInfoResource,
} from '../model/types'

import { parseDraftNumber } from './formatters'

const normalizeProcedureValue = (value: number | null | undefined) =>
  typeof value === 'number' && Number.isFinite(value) ? value : 0

const YEARS = [1, 2, 3, 4, 5] as const

export const mapProcedureRowToPartnerDevicesInfoResource = (
  row: PartnerDevicesInfoProcedureRow,
  context?: {
    partnerId?: string
    fYear?: number
  }
): PartnerDevicesInfoResource => {
  return {
    partnerId: context?.partnerId ?? '',
    fYear: context?.fYear ?? 0,
    data: {
      a3AllBrands: normalizeProcedureValue(row.A3AllBrands),
      a3HpBrand: normalizeProcedureValue(row.A3HP),
      a4AllBrands: normalizeProcedureValue(row.A4AllBrands),
      a4HpBrand: normalizeProcedureValue(row.A4HP),
      phyContractualUnitsA3: normalizeProcedureValue(row.PHYA3),
      phyContractualUnitsA4: normalizeProcedureValue(row.PHYA4),
      hpBrandsOverLastYears: YEARS.reduce(
        (acc, year) => {
          acc[year] = {
            a3: normalizeProcedureValue(row[`P${year}YA3`]),
            a4: normalizeProcedureValue(row[`P${year}YA4`]),
          }

          return acc
        },
        {} as PartnerDevicesInfoData['hpBrandsOverLastYears']
      ),
    },
  }
}

export const createDraftFromData = (data: PartnerDevicesInfoData): PartnerDevicesInfoDraft => ({
  a3AllBrands: String(data.a3AllBrands),
  a3HpBrand: String(data.a3HpBrand),
  a4AllBrands: String(data.a4AllBrands),
  a4HpBrand: String(data.a4HpBrand),
  overLastYears: null,
})

export const getHpBrandsByYears = (
  data: PartnerDevicesInfoData,
  overLastYears: PartnerDevicesInfoOverLastYears
) => data.hpBrandsOverLastYears[overLastYears]

export const applyDraftToResource = (
  resource: PartnerDevicesInfoResource,
  draft: PartnerDevicesInfoDraft
): PartnerDevicesInfoResource => ({
  ...resource,
  data: {
    ...resource.data,
    a3AllBrands: parseDraftNumber(draft.a3AllBrands) ?? resource.data.a3AllBrands,
    a3HpBrand: parseDraftNumber(draft.a3HpBrand) ?? resource.data.a3HpBrand,
    a4AllBrands: parseDraftNumber(draft.a4AllBrands) ?? resource.data.a4AllBrands,
    a4HpBrand: parseDraftNumber(draft.a4HpBrand) ?? resource.data.a4HpBrand,
  },
})
